import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, DateTimeField } from './util';
import { GameStatisticBase } from './game-statistic-base';

@ModelInstance({
  mappingFields: {
    game_user_id: 'gameUserId',
    points: 'points',
    free_throws_made: 'freeThrowsMade',
    two_points_made: 'twoPointsMade',
    three_points_made: 'threePointsMade',
    one_points_made: 'onePointsMade',
    two_point_attempts: 'twoPointAttempts',
    three_point_attempts: 'threePointAttempts',
    free_throw_attempts: 'freeThrowAttempts',
    one_point_attempts: 'onePointAttempts',
    one_point_percent: 'onePointPercent',
    two_point_percent: 'twoPointPercent',
    three_point_percent: 'threePointPercent',
    free_throw_percent: 'freeThrowPercent',
    four_point_percent: 'fourPointPercent',
    assists: 'assists',
    blocks: 'blocks',
    rebounds: 'rebounds',
    offensive_rebounds: 'offensiveRebounds',
    defensive_rebounds: 'defensiveRebounds',
    steals: 'steals',
    turnovers: 'turnovers',
    personal_fouls: 'personalFouls',
    technical_fouls: 'technicalFouls',
    unsportsmanlike_fouls: 'unsportsmanlikeFouls',
    disqualification_fouls: 'disqualificationFouls',
    drawn_fouls: 'drawnFouls',
    player_efficiency: 'playerEfficiency',
    shots_blocked: 'shotsBlocked',
    four_point_attempts: 'fourPointAttempts',
    four_points_made: 'fourPointsMade',
    dunk_attempts: 'dunkAttempts',
    dunks_made: 'dunksMade',
    shootouts_won: 'shootoutsWon',
    shootouts_lost: 'shootoutsLost',
    shootouts_total: 'shootoutsTotal',
    shootout_won_percent: 'shootoutWonPercent',
    moneyball_free_throw_attepts: 'moneyballFreeThrowAttepts',
    moneyball_free_throws_made: 'moneyballFreeThrowsMade',
    plus_minus: 'plusMinus',
    game_time: 'gameTime',
    updated_at: 'updatedAt',
  },
  relation: {
    updatedAt: DateTimeField,
  }
})
export class BasketballGameStatistic extends BaseModel implements GameStatisticBase {
  gameUserId: number;
  points: number;
  freeThrowsMade: number;
  twoPointsMade: number;
  threePointsMade: number;
  onePointsMade: number;
  twoPointAttempts: number;
  threePointAttempts: number;
  freeThrowAttempts: number;
  onePointAttempts: number;
  assists: number;
  blocks: number;
  rebounds: number;
  offensiveRebounds: number;
  defensiveRebounds: number;
  steals: number;
  turnovers: number;
  personalFouls: number;
  technicalFouls: number;
  unsportsmanlikeFouls: number;
  disqualificationFouls: number;
  drawnFouls: number;
  playerEfficiency: number;
  shotsBlocked: number;
  fourPointAttempts: number;
  fourPointsMade: number;
  dunkAttempts: number;
  dunksMade: number;
  shootoutsWon: number;
  shootoutsLost: number;
  moneyballFreeThrowAttepts: number;
  moneyballFreeThrowsMade: number;
  plusMinus: number;
  gameTime: number;
  updatedAt: Date;

  get id(): number {
    return this.gameUserId;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}

  get totalFouls(): number {
    return (this.personalFouls || 0) + (this.technicalFouls || 0) + (this.unsportsmanlikeFouls || 0) + (this.disqualificationFouls || 0);
  }

  set onePointPercent(v: number) {}

  get onePointPercent(): number {
    if (!this.onePointsMade || !this.onePointAttempts) {
      return 0;
    }
    return Math.round(1000 * this.onePointsMade / this.onePointAttempts) / 10;
  }

  /**
   * @deprecated Use onePointPercent instead
   */
  get onePointsPercent(): number {
    if (!this.onePointsMade || !this.onePointAttempts) {
      return 0;
    }
    return Math.round(1000 * this.onePointsMade / this.onePointAttempts) / 10;
  }

  set twoPointPercent(v: number) {}

  get twoPointPercent(): number {
    if (!this.twoPointsMade || !this.twoPointAttempts) {
      return 0;
    }
    return Math.round(1000 * this.twoPointsMade / this.twoPointAttempts) / 10;
  }

  /**
   * @deprecated Use twoPointPercent instead
   */
  get twoPointsPercent(): number {
    if (!this.twoPointsMade || !this.twoPointAttempts) {
      return 0;
    }
    return Math.round(1000 * this.twoPointsMade / this.twoPointAttempts) / 10;
  }

  set threePointPercent(v: number) {}

  get threePointPercent(): number {
    if (!this.threePointsMade || !this.threePointAttempts) {
      return 0;
    }
    return Math.round(1000 * this.threePointsMade / this.threePointAttempts) / 10;
  }

  /**
   * @deprecated Use threePointPercent instead
   */
  get threePointsPercent(): number {
    if (!this.threePointsMade || !this.threePointAttempts) {
      return 0;
    }
    return Math.round(1000 * this.threePointsMade / this.threePointAttempts) / 10;
  }

  set freeThrowPercent(v: number) {}

  get freeThrowPercent(): number {
    if (!this.freeThrowsMade || !this.freeThrowAttempts) {
      return 0;
    }
    return Math.round(1000 * this.freeThrowsMade / this.freeThrowAttempts) / 10;
  }

  /**
   * @deprecated Use freeThrowPercent instead
   */
  get freeThrowsPercent(): number {
    if (!this.freeThrowsMade || !this.freeThrowAttempts) {
      return 0;
    }
    return Math.round(1000 * this.freeThrowsMade / this.freeThrowAttempts) / 10;
  }

  get totalRebounds(): number {
    return Math.floor(10 * ((this.offensiveRebounds || 0) + (this.defensiveRebounds || 0))) / 10;
  }

  set fourPointPercent(v: number) {}

  get fourPointPercent(): number {
    if (!this.fourPointAttempts || !this.fourPointsMade) {
      return 0;
    }
    return Math.round(1000 * this.fourPointsMade / this.fourPointAttempts) / 10;
  }

  set shootoutsTotal(v: number) {}

  get shootoutsTotal(): number {
    return (this.shootoutsLost || 0) + (this.shootoutsWon || 0);
  }

  set shootoutWonPercent(v: number) {}

  get shootoutWonPercent(): number {
    if (!this.shootoutsTotal || !this.shootoutsWon) {
      return 0;
    }
    return Math.round(1000 * this.shootoutsWon / this.shootoutsTotal) / 10;
  }

  set moneyballFreeThrowPercent(v: number) {}

  get moneyballFreeThrowPercent() {
    if (!this.moneyballFreeThrowsMade || !this.moneyballFreeThrowAttepts) {
      return 0;
    }
    return Math.round(1000 * this.moneyballFreeThrowsMade / this.moneyballFreeThrowAttepts) / 10;

  }
}
